import React from "react";

export default function Terms() {
  return (
    <section className="py-10 bg-white">
      <div className="max-w-[1100px] mx-auto px-4 prose prose-slate">
        <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>

        <h2>1. Geltungsbereich</h2>
        <p>Diese AGB gelten für Umzugsleistungen von Daraa Umzug Berlin gegenüber Verbraucher:innen und Unternehmer:innen.</p>

        <h2>2. Leistungen</h2>
        <p>Leistungsumfang gemäß Angebot/Auftragsbestätigung (z. B. Tragehelfer, LKW, Montage).</p>

        <h2>3. Preise &amp; Zahlung</h2>
        <p>Preise gemäß Angebot; Zahlungsziel und -art hier definieren.</p>

        <h2>4. Termine &amp; Stornierung</h2>
        <p>Regeln zu Verschiebung/Absage; ggf. Stornogebühren und Fristen hier definieren.</p>

        <h2>5. Haftung</h2>
        <p>Gesetzliche Haftung; Besonderheiten bei Transport-/Montageschäden, Versicherungshinweise (z. B. Haftungsbegrenzungen nach HGB/Speditionsbedingungen) angeben.</p>

        <h2>6. Datenschutz</h2>
        <p>Es gilt unsere <a href="/datenschutz">Datenschutzerklärung</a> (Art. 13 DSGVO).</p>

        <h2>7. Verbraucherstreitbeilegung</h2>
        <p>Hinweis gem. § 36 VSBG: Wir sind weder verpflichtet noch bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

        <h2>8. Schlussbestimmungen</h2>
        <p>Gerichtsstand, anwendbares Recht, salvatorische Klausel etc.</p>

        <p className="text-sm opacity-70">Hinweis: Diese Vorlage ist ein Platzhalter und ersetzt keine Rechtsberatung.</p>
      </div>
    </section>
  );
}
